import { ForwardedRef, forwardRef } from "react";
import { useRoot } from "../../contexts/Root";
import styles from "./Button.module.css";

interface Props {
  children: React.ReactNode;
  onClick: () => void;
  emphasize?: boolean;
}

export const Button = forwardRef(
  (
    { children, onClick, emphasize = false }: Props,
    ref: ForwardedRef<HTMLButtonElement>
  ) => {
    const {
      theme: { foreground, emphasis },
    } = useRoot();

    const style = {
      color: foreground,
      background: emphasize ? emphasis : undefined,
    };

    return (
      <button
        ref={ref}
        onClick={onClick}
        style={style}
        className={styles.button}
      >
        {children}
      </button>
    );
  }
);
